import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './i18n/config';

// Gestionnaire d'erreurs global pour capturer les erreurs non gérées
// (notamment celles venant d'extensions de navigateur)
window.addEventListener('error', (event) => {
  // Ignorer les erreurs provenant d'extensions de navigateur
  const isExtensionError = 
    event.filename?.includes('extension') ||
    event.filename?.includes('chrome-extension') ||
    event.filename?.includes('moz-extension') ||
    event.message?.includes('onboarding') ||
    !event.filename; // Erreurs sans fichier source = souvent des extensions
  
  if (isExtensionError) {
    console.warn('[Wanzo] Erreur d\'extension ignorée:', event.message);
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
});

// Capturer les rejections de promesses non gérées
window.addEventListener('unhandledrejection', (event) => {
  // Ignorer les erreurs d'extensions
  const errorMessage = event.reason?.message || String(event.reason);
  const isExtensionError = 
    errorMessage.includes('onboarding') ||
    errorMessage.includes('extension') ||
    errorMessage.includes('Cannot set properties of null');
  
  if (isExtensionError) {
    console.warn('[Wanzo] Rejet de promesse d\'extension ignoré:', errorMessage);
    event.preventDefault();
    return;
  }
});

const rootElement = document.getElementById('root');

if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
} else {
  console.error('[Wanzo] Élément root non trouvé - impossible de monter l\'application');
}
